export enum ResourceType {
  PREMIUM = 'premium',
  ENERGY = 'energy',
  BUILD = 'build',
}
